import Config from './config'
import { $post, $get } from './http'
import Store from '@/store'

const cookieApi = {}

for (const key in Config.apis) {
    cookieApi[key] = (params, VISITOR_HEADER, props = {}) => {
        return new Promise((resolve, reject) => {
            const lan = Store.state.lang
            const token = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).token : ''
            if (VISITOR_HEADER) {
                $post(Config.apiBaseUrl + Config.apis[key], params, {
                    tenantId: lan === 'en' ? Config.enTenantId : Config.tenantId,
                    VISITOR_HEADER
                }).then((res) => {
                    props.callback && props.callback(res)
                    if (res.status === 0) {
                        resolve(res.data)
                    } else {
                        !props.noToast && window.$toast && res.message && window.$toast(res.message)
                        reject(res.status)
                    }
                }).catch((err) => {
                    reject(err)
                })
            } else {
                $post(Config.apiBaseUrl + Config.apis[key], params, {
                    tenantId: lan === 'en' ? Config.enTenantId : Config.tenantId,
                    'Authorization-API': token ? `bearer ${token}` : ''
                }).then((res) => {
                    props.callback && props.callback(res)
                    if (res.status === 0) {
                        resolve(res.data)
                    } else {
                        !props.noToast && window.$toast && res.message && window.$toast(res.message)
                        reject(res.status)
                    }
                }).catch((err) => {
                    reject(err)
                })
            }
        })
    }
    cookieApi[`$get${key}`] = (params, VISITOR_HEADER, props = {}) => {
        return new Promise((resolve, reject) => {
            const lan = Store.state.lang
            const token = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).token : ''
            if (VISITOR_HEADER) {
                $get(Config.apiBaseUrl + Config.apis[key], params, {
                    tenantId: lan === 'en' ? Config.enTenantId : Config.tenantId,
                    VISITOR_HEADER

                }).then((res) => {
                    props.callback && props.callback(res)
                    if (res.status === 0) {
                        resolve(res.data)
                    } else {
                        !props.noToast && window.$toast && res.message && window.$toast(res.message)
                        reject(res.status)
                    }
                }).catch((err) => {
                    reject(err)
                })
            } else {
                $get(Config.apiBaseUrl + Config.apis[key], params, {
                    tenantId: lan === 'en' ? Config.enTenantId : Config.tenantId,
                    'Authorization-API': token ? `bearer ${token}` : ''
                }).then((res) => {
                    props.callback && props.callback(res)
                    if (res.status === 0) {
                        resolve(res.data)
                    } else {
                        !props.noToast && window.$toast && res.message && window.$toast(res.message)
                        reject(res.status)
                    }
                }).catch((err) => {
                    reject(err)
                })
            }
        })
    }
}

export default cookieApi